/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_IndonesianInputs */

const en_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesian`)
};

const fr_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesien`)
};

const de_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesisch`)
};

const it_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`indonesiano`)
};

const ru_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`индонезийский`)
};

const es_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`indonesio`)
};

const zh_cn2_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`印度尼西亚`)
};

const ja_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インドネシア語`)
};

const hi_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इन्डोनेशियाई`)
};

const pt_pt2_speechmatics_target_language_indonesian = /** @type {(inputs: Speechmatics_Target_Language_IndonesianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`indonésio`)
};

/**
* | output |
* | --- |
* | "Indonesian" |
*
* @param {Speechmatics_Target_Language_IndonesianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_indonesian = /** @type {((inputs?: Speechmatics_Target_Language_IndonesianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_IndonesianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_indonesian(inputs)
	if (locale === "de") return de_speechmatics_target_language_indonesian(inputs)
	if (locale === "it") return it_speechmatics_target_language_indonesian(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_indonesian(inputs)
	if (locale === "es") return es_speechmatics_target_language_indonesian(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_indonesian(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_indonesian(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_indonesian(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_indonesian(inputs)
	return en_speechmatics_target_language_indonesian(inputs)
});